export const DATE_INPUT_TYPE = 'dateInputType';
export const START_DATE_FIELD = 'startDate';
export const END_DATE_FIELD = 'endDate';

export type FormData = {
  [DATE_INPUT_TYPE]: string;
  [START_DATE_FIELD]: string;
  [END_DATE_FIELD]: string;
};

export const TODAY = 'today';
export const YESTERDAY = 'yesterday';
export const CUSTOM = 'custom';

export const DATE_INPUT_OPTIONS = [
  {
    label: 'Today',
    value: TODAY,
  },
  {
    label: 'Yesterday',
    value: YESTERDAY,
  },
  {
    label: 'Custom',
    value: CUSTOM,
  },
];
